import { FormPhoneInput } from 'widget/event_components/phone-input';
import { Form } from 'react-bootstrap';
import * as E from './elements';
import { Checkbox } from '@mui/material';
import { DatePickerInput } from 'widget/event_components/date-picker';
import { OptionDropdown } from 'widget/event_components/Ticket/components/OptionDropdown';
import { useMemo, Fragment } from 'react';
import { CustomRadio } from './elements';
import { WaiverTermsQuestion } from './WaiverTermsQuestion';

export const QuestionType = ({ errors, question, setCustomField, form = {}, event }) => {
  const questionText = question.question;
  const isError = !!errors[`custom_${questionText}`];

  const InputQuestion = useMemo(() => (question.mapping === 'phone' ? FormPhoneInput : Form.Control), [question]);

  const { options = '' } = question;

  if (question.type === 'input')
    return (
      <Fragment>
        <InputQuestion
          placeholder="Write here..."
          required={question.required}
          isInvalid={!!errors[`custom_${questionText}`]}
          onChange={(e) => setCustomField('input', question)(questionText, e.target.value)}
          defaultValue={form[question.mapping]}
          timezone={event.get('timezone')}
          type="text"
        />
        {isError && <E.ErrorMessage>{errors[`custom_${questionText}`]}</E.ErrorMessage>}
      </Fragment>
    );

  if (question.type === 'radio')
    return (
      <E.CustomRadioGroup onChange={(e) => setCustomField('radio', question)(questionText, e.target.value)}>
        {options.split('\n').map((option, index) => (
          <E.RadioWrapper>
            <CustomRadio
              sx={{
                '&': {
                  color: '#D8D8D8',
                },
                '&.Mui-checked': {
                  color: '#9D25DC',
                },
              }}
              label={option}
              value={option}
              id={`${questionText}--${index}`}
              name={`radio-option-${questionText}`}
            />
            <E.Label as="span">{option}</E.Label>
          </E.RadioWrapper>
        ))}
        {isError && <E.ErrorMessage>{errors[`custom_${questionText}`]}</E.ErrorMessage>}
      </E.CustomRadioGroup>
    );

  if (question.type === 'dropdown') {
    return (
      <Fragment>
        <OptionDropdown setCustomField={setCustomField} questionText={questionText} question={question} options={options} errors={errors} />
      </Fragment>
    );
  }

  if (question.type === 'terms') return <WaiverTermsQuestion question={question} setCustomField={setCustomField} errors={errors} />;

  if (question.type === 'datepicker')
    return (
      <Fragment>
        <DatePickerInput
          error={errors[`custom_${questionText}`]}
          defaultValue={form[question.mapping]}
          onChange={(val) => setCustomField('datepicker', question)(questionText, val)}
        />
      </Fragment>
    );

  if (question.type === 'checkbox')
    return (
      <Fragment>
        <fieldset onChange={(e) => setCustomField('checkbox', question)(questionText, e.target.value, e.target.checked)}>
          {options.split('\n').map((option, index) => (
            <E.Form
              type="checkbox"
              label={option}
              name={`checkbox-option-${questionText}`}
              value={option}
              id={`${questionText}--${index}`}
              isInvalid={!!errors[`custom_${questionText}`]}
            >
              <Checkbox
                icon={<img src="https://cdn.ticketspot.io/widget/layout-icons/custom-checkout-icon.svg" alt="o" />}
                checkedIcon={<img src="https://cdn.ticketspot.io/widget/layout-icons/custom-checkout-checked.svg" alt="x" />}
                value={option}
                id={`${questionText}--${index}`}
                name={`checkbox-option-${questionText}`}
              />
              <E.Label as="span">{option}</E.Label>
            </E.Form>
          ))}
        </fieldset>
        {isError && <E.ErrorMessage>{errors[`custom_${questionText}`]}</E.ErrorMessage>}
      </Fragment>
    );

  return <span />;
};
